import { render, staticRenderFns } from "./ServicesTable.vue?vue&type=template&id=13015f2c&"
import script from "./ServicesTable.vue?vue&type=script&lang=ts&"
export * from "./ServicesTable.vue?vue&type=script&lang=ts&"
import style0 from "./ServicesTable.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports